import { render } from "./ComprobantesSiiafEmbargoPersonaComponent.vue?vue&type=template&id=68f0d7d4"
import script from "./ComprobantesSiiafEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./ComprobantesSiiafEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__